import type { NextPage } from "next"

import ImageThumbnail from "@features/generators/image-thumbnail"

import Page from "@shared/ui/page"

const ImageThumbnailPage: NextPage = () => {
  return (
    <Page title={"Image Thumbnail"}>
      <ImageThumbnail />
    </Page>
  )
}

export default ImageThumbnailPage
